import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import { borderCollapseInherit, fontSize10 } from '../../helpers/invoice_styles';
import I18n from '../../common/I18n';
import { checkNegitive, findTotal } from '../../common/Common';
import { findSpanValue } from '../../helpers/billing';
import _ from 'lodash';

const InvoiceChargesSection = ({
  chargeType,
  charges,
  title,
  findSectionTotal,
  section,
}) => {
  const priceList = !isEmpty(charges) && charges.length > 0
    ? charges.map((order) => order.price_list)
    : [];
  const flattenList = _.flatten(priceList);

  return (
    <Row className="charges-table-view">
      {charges?.length > 0 && (
        <Col>
          <table
            cellPadding="5px"
            cellSpacing="0px"
            width="100%"
            style={{ ...borderCollapseInherit }}
            className="charge-details-table"
          >
            <tbody>
              <tr>
                <td width="245px" className="table-heading">
                  {title}
                </td>
                <td width="148px" className="table-heading alignRight">
                  Quantity
                </td>
                <td width="148px" className="table-heading alignRight">
                  {I18n.t("invoices.amount")}
                </td>
              </tr>
              {charges.map((order, index) => {
                const priceList = !isEmpty(order.price_list) ? order.price_list : [];
                return priceList.length > 0 ? (
                  <Fragment key={index}>
                    {priceList.map((item, itemIndex) => {
                      const rowSpan = findSpanValue(priceList, item, itemIndex);
                      return (
                        <tr key={itemIndex}>
                          <td className="tbody-item-body">
                            {item.invoice_name}{" "}
                            {item.item_description ? (
                              <i style={{ ...fontSize10 }}>
                                {item.item_description}
                              </i>
                            ) : null}
                            {item.added_from === "MANUAL" && (
                              <sup className="textRed textBold">M</sup>
                            )}
                          </td>
                          {rowSpan !== 0 && (
                            <td
                              className="tbody-item-body alignRight"
                              rowSpan={rowSpan}
                            >
                              {rowSpan === 1 ? (
                                !isEmpty(item.invoice_quantity) &&
                                  item.invoice_quantity !== 0 ? (
                                  item.invoice_quantity
                                ) : (
                                  <Fragment>&nbsp;</Fragment>
                                )
                              ) : (
                                rowSpan
                              )}
                            </td>
                          )}
                          {rowSpan !== 0 && (
                            <td
                              className="tbody-item-body alignRight"
                              rowSpan={rowSpan}
                            >
                              {checkNegitive(item.invoice_value)}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </Fragment>
                ) : null;
              })}
              <tr>
                <td>{" "}</td>
                <td className="invoice-sub-total alignRight">
                  {I18n.t("invoices.sub_total")}
                </td>
                <td className="invoice-sub-total alignRight">
                  {findSectionTotal(chargeType)}
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      )}
    </Row>
  );
};

InvoiceChargesSection.propTypes = {
  chargeType: PropTypes.string.isRequired,
  charges: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  findSectionTotal: PropTypes.func.isRequired,
  section: PropTypes.object,
};

export default InvoiceChargesSection; 